<template>
  <b-container fluid id="news" class="page">
    <h1>News</h1>
    <div class="d-flex justify-content-start align-items-center flex-wrap">
      <b-form-select
        v-model="selected_year"
        :options="options_year"
        class="m-md-2 dropdown-publications-years"
        @change="requestNews"
      ></b-form-select>
    </div>

    <div class="d-flex justify-content-start align-items-center flex-wrap">
      <b-form-select
        v-model="selected_sort"
        :options="options_sort"
        class="m-md-2 dropdown-publications-years"
        style="width: 18em !important"
      ></b-form-select>
    </div>

    <div
      v-if="
        next_page_url !== null && selected_sort === 'Sort by date, oldest first'
      "
    >
      <b-button
        class="load-more-button top"
        variant="primary"
        v-if="!loadingMoreNews"
        @click="loadMoreNews"
      >
        Load Older News
      </b-button>
      <loading class="loading-animation" v-else></loading>
    </div>

    <div v-if="ordered_news.length !== 0">
      <div v-for="article in ordered_news" :key="article.id" id="all-news">
        <piece :article_data="article"></piece>
      </div>
    </div>
    <div v-else id="no-data" class="d-flex">
      <span><font-awesome icon="exclamation" fixed-width /></span>
      <p>No articles have been added yet!</p>
    </div>

    <div v-if="next_page_url !== null && selected_sort === 'Sort by date, newest first'">
      <b-button
        class="load-more-button bottom"
        variant="primary"
        v-if="!loadingMoreNews"
        @click="loadMoreNews"
      >
        Load More News
      </b-button>
      <loading class="loading-animation" v-else></loading>
    </div>
  </b-container>
</template>

<script>
import Piece from "@/components/Article.vue";
import Loading from "@/components/Loading.vue";
import { getPaginationData, getByFullURL } from "@/api";

export default {
  name: "News",
  components: {
    Piece,
    Loading,
  },
  created() {
    this.requestNews();
  },
  data() {
    return {
      news: [],
      next_page_url: null,
      loadingMoreNews: false,
      selected_year: "All Years",
      options_year: ["All Years", ...this.page.available_years.reverse()],
      selected_sort: "Sort by date, newest first",
      options_sort: [
        "Sort by date, newest first",
        "Sort by date, oldest first",
      ],
    };
  },
  computed: {
    ordered_news() {
      const tempNews = [...this.news];
      return this.selected_sort === "Sort by date, oldest first"
        ? tempNews.reverse()
        : tempNews;
    },
  },
  methods: {
    loadMoreNews() {
      this.loadingMoreNews = true;
      getByFullURL(this.next_page_url).then((response) => {
        this.news = [...this.news.concat(response.data.results)];
        this.next_page_url = response.data.next;
        this.loadingMoreNews = false;
      });
    },
    requestNews() {
      getPaginationData("news", { vcmi: 1, year: this.selected_year }).then(
        (response) => {
          this.news = response.data.results;
          this.next_page_url = response.data.next;
        }
      );
    },
  },
  props: ["page"],
};
</script>

<style lang="scss">
#news {
  #all-news {
    > * {
      margin-bottom: 4em !important;
    }

    :last-child {
      margin-bottom: 0;
    }

    :first-child {
      margin-top: 1em;
    }
  }

  .loading-animation {
    position: relative;
    transform: scale(0.6);
  }

  .load-more-button.bottom {
    display: block !important;
    margin-top: 8em !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }

  .load-more-button.top {
    display: block !important;
    margin-bottom: 2em !important;
    margin-top: 2em !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }
}
</style>
